module.exports = __webpack_public_path__ + "img/seedssa.0d428ac5.jpg";